import { FC, ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import StatusTag from './StatusTag';

type StatusVariant = 'green' | 'blue' | 'gold' | 'orange' | 'red' | 'teal' | 'purple' | 'gray';

interface ContactHeaderProps {
  initials: string;
  name: string;
  subtitle: string;
  statusLabel?: string;
  statusVariant?: StatusVariant;
  children?: ReactNode;
}

const ContactHeader: FC<ContactHeaderProps> = ({
  initials,
  name,
  subtitle,
  statusLabel,
  statusVariant,
  children,
}) => (
  <Stack direction="row" alignItems="center" gap={3}>
    <Box
      sx={{
        width: 52,
        height: 52,
        borderRadius: '50%',
        bgcolor: 'primary.main',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Typography variant="seitentitel" sx={{ color: 'primary.contrastText', lineHeight: 1 }}>
        {initials}
      </Typography>
    </Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Stack direction="row" alignItems="center" gap={2}>
        <Typography variant="titelGross">
          {name}
        </Typography>
        {statusLabel && statusVariant && (
          <StatusTag label={statusLabel} variant={statusVariant} />
        )}
      </Stack>
      <Typography variant="meta" sx={{ mt: 1 }}>
        {subtitle}
      </Typography>
    </Box>
    {children}
  </Stack>
);

export default ContactHeader;
